/* import __COLOCATED_TEMPLATE__ from './exit-dialog.hbs'; */
import Component from '@glimmer/component';
export default class ExitDialog extends Component {}